import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { createForm } from 'src/app/components/shindan-form/shindan-form.form';

@Component({
  selector: 'app-shindan-form',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './shindan-form.component.html',
  styleUrl: './shindan-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShindanFormComponent {
  readonly #http = inject(HttpClient);
  readonly cities = input<string>('');
  readonly countries = input<string>('');
  readonly type = input<string>('留学');
  readonly lpType = input<string>('');

  readonly countriesArray = computed(() => {
    const cities = this.cities().split(',').map(city => city.trim()).filter(city => city !== '');
    const countries = this.countries().split(',').map(country => country.trim()).filter(country => country !== '');
    if (cities.length === 0) {
      cities.push(...countries);
    }
    cities.push('その他', 'まだわからない');
    return cities;
  });

  protected readonly hasCity = computed(() => {
    const cities = this.cities().split(',').map(city => city.trim()).filter(city => city !== '');
    return cities.length > 0;
  });

  protected readonly form = createForm();
  protected readonly sending = signal(false);

  protected countryChange(event: any) {
    const country = event.target.value;
    const currentValue = this.form.getRawValue().countries;
    if (event.target.checked) {
      if (!currentValue.includes(country)) {
        currentValue.push(country);
      }
    } else {
      if (currentValue.includes(country)) {
        const index = currentValue.indexOf(country);
        currentValue.splice(index, 1);
      }
    }
    this.form.patchValue({ countries: currentValue });
  }

  protected submit() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      const key = Object.keys(this.form.controls).find(key => (this.form.controls as any)[key].invalid)!;
      const element = window.document.querySelector(`#${key}`) as HTMLElement;
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const value = this.form.getRawValue();
    const searchParams = sessionStorage.getItem('search-parameter');
    if (searchParams !== null) {
      (value as any).searchParameter = searchParams;
    }
    const prize = sessionStorage.getItem('prize');
    if (prize !== null) {
      (value as any).prize = Number(prize.replace(/[^0-9]/g, ""));
    }

    (value as any).isShindan = true;
    (value as any).lpType = this.lpType();
    (value as any).hasCity = this.hasCity();
    this.sending.set(true);
    this.#http.post('api/reservations', value)
      .subscribe({
        next: () => {
          sessionStorage.setItem('shindan-form', JSON.stringify(value));
          window.location.href = '/ab/plan-check-complete';
        }
      });
  }

  protected hasError(control: FormControl, errorKey: string) {
    return control.touched && control.hasError(errorKey);
  }
}
